import UploadNewsForm from "../../UploadNewsForm";
import { createPastoralActivity } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewPastoralActivity() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createPastoralActivity(title, description, image);
      if (result) {
        navigate("/pastoral-activity/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Pastoral Activities"}
          breadCrumbText={"Create New"}
          goBackLink={"/pastoral-activity/all"}
        />
      </Container>
    </>
  );
}
